import React from 'react'

// material ui
import Typography from '@mui/material/Typography'

// shared components
import PersonCard from 'components/shared/PersonCard'
import AdultStatus from 'components/shared/AdultStatus'

// local components
import EditButton from './EditButton'
import RemoveButton from './RemoveButton'
import DeletePickupPersonModal from './DeletePickupPersonModal'

export default function PickupPerson(props) {
  const { adult, type, editable, setModal, reupRequired } = props
  const relationship = adult.relationshipToCampers

  return (
    <PersonCard
      header={
        <AdultStatus
          adult={adult}
          type={type}
          relationship={relationship}
          reupRequired={reupRequired}
        />
      }
      desktopButtons={
        editable ? (
          <>
            <EditButton
              align='right'
              adult={adult}
              reupRequired={reupRequired}
            />
            <RemoveButton align='right' adult={adult} setModal={setModal} />
          </>
        ) : null
      }
      mobileButtons={
        editable ? (
          <>
            <EditButton adult={adult} reupRequired={reupRequired} />
            <RemoveButton adult={adult} setModal={setModal} />
          </>
        ) : null
      }
    >
      <Typography variant='body1'>{adult.primaryPhone}</Typography>
      <DeletePickupPersonModal pickupPerson={adult} />
    </PersonCard>
  )
}
